import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";
import {Source} from "../../model/mapping/source";

@Injectable({
  providedIn: 'root'
})
export class MappingSourceService extends CommonCrudService<Source> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_SOURCE_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_SOURCE,
      CrystalclearMappingBackUrl.DELETE_MAPPING_SOURCE);
  }

}
